export default "__VITE_ASSET__DvRXath4__"